import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-intl/src/components/injectIntl';
import axios from 'axios';

// Configure global axios interceptor to attach tenant-id header to every request
axios.interceptors.request.use(
  (config) => {
    const tenantId = localStorage.getItem('tenantId');
    if (tenantId) {
      if (!config.headers) {
        config.headers = {};
      }
      config.headers['tenant-id'] = tenantId;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.Fragment>
    <Provider>
      <App />
    </Provider>
  </React.Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
